import { SpaceShapeId } from 'utils/space-polygon';
import ShapeSubmenuButton from './shape-submenu-button';
import { getShapeIconVertices } from './shape-submenu-icon-vertices';

type ShapeSubmenuProps = {
  onSelect: (shape: SpaceShapeId) => void;
  onClose: () => void;
};

type ShapeRow = {
  rowLabel: string;
  shapes: { id: SpaceShapeId; label: string }[];
};

const SHAPE_ROWS: ShapeRow[] = [
  {
    rowLabel: 'Rectangle',
    shapes: [
      { id: 'rectangle', label: 'Square' },
      { id: 'rectangle-landscape', label: 'Landscape rectangle' },
      { id: 'rectangle-portrait', label: 'Portrait rectangle' },
      { id: '+', label: 'Plus shape' }
    ]
  },
  {
    rowLabel: 'L',
    shapes: [
      { id: 'L-tl', label: 'L shape with corner at top-left' },
      { id: 'L-bl', label: 'L shape with corner at bottom-left' },
      { id: 'L-br', label: 'L shape with corner at bottom-right' },
      { id: 'L-tr', label: 'L shape with corner at top-right' }
    ]
  },
  {
    rowLabel: 'T',
    shapes: [
      { id: 'T-down', label: 'T shape with stem down' },
      { id: 'T-right', label: 'T shape with stem right' },
      { id: 'T-up', label: 'T shape with stem up' },
      { id: 'T-left', label: 'T shape with stem left' }
    ]
  },
  {
    rowLabel: 'U',
    shapes: [
      { id: 'U-up', label: 'U shape with opening up' },
      { id: 'U-down', label: 'U shape with opening down' },
      { id: 'U-left', label: 'U shape with opening left' },
      { id: 'U-right', label: 'U shape with opening right' }
    ]
  },
  {
    rowLabel: 'Triangle',
    shapes: [
      { id: 'triangle-up', label: 'Triangle pointing up' },
      { id: 'triangle-right', label: 'Triangle pointing right' },
      { id: 'triangle-down', label: 'Triangle pointing down' },
      { id: 'triangle-left', label: 'Triangle pointing left' }
    ]
  }
];

const COLUMNS = 4;
const BUTTON_SIZE = 40;

export default function ShapeSubmenu({ onSelect, onClose }: ShapeSubmenuProps) {
  const handleSelect = (shape: SpaceShapeId) => {
    onSelect(shape);
    onClose();
  };

  return (
    <div className='p-2'>
      <div
        className='grid gap-1.5'
        style={{
          gridTemplateColumns: `repeat(${COLUMNS}, ${BUTTON_SIZE}px)`
        }}
      >
        {SHAPE_ROWS.flatMap((row) => {
          const cells = row.shapes.map((shape) => (
            <ShapeSubmenuButton
              key={shape.id}
              vertices={getShapeIconVertices(shape.id)}
              onClick={() => handleSelect(shape.id)}
              ariaLabel={shape.label}
              size={BUTTON_SIZE}
            />
          ));
          const fillerCount = Math.max(0, COLUMNS - row.shapes.length);
          const fillers = Array.from({ length: fillerCount }, (_, i) => (
            <div
              key={`filler-${row.rowLabel}-${i}`}
              style={{ width: BUTTON_SIZE, height: BUTTON_SIZE }}
            />
          ));
          return [...cells, ...fillers];
        })}
      </div>
    </div>
  );
}
